import React from "react";
// import FeemonkLogo from "../../../images/hero_icon.svg";
// import ProfileIcon from "../../../images/icons/profile.svg";
// import FeemonkLogo from "../../../images/IMG_0793-removebg-preview.png";
import MonkCapitalLogo from "../../../images/monk_capital_logo_edit.png";
import FeemonkLogo from "../../../../images/FeeMonk-HighRes-Logo.png";
import ProfileIcon from "../../../images/icons/profile_insurefin.svg";
import DownloadIcon from "../../../images/icons/download.svg";
import styles from "./index.module.css";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useLocation } from "react-router-dom";
import fundzpe from "../../../images/fundz-pe-logo.png"

function Navbar() {
  const token = sessionStorage.getItem("data") as string

  const location = useLocation();

  return (
    <div className={styles.navbar}>
      <Link to="/mainpage">
        <img
          style={{ width: "12rem", height:location?.state?.data?.channelId === 5? "2rem" :"6rem"}}
          src={location?.state?.data?.channelId === 5 ? MonkCapitalLogo:FeemonkLogo}
          alt=""
          className={styles.logo}
        />
      </Link>
      
      <div className={styles.footerRight}>
        {/* <div className={styles.downloadButton}>
          <p style={{ fontSize: "1rem", textAlign: "center" }}>Download App</p>
        </div> */}
        {/* <img
          style={{ width: "3rem", height: "3rem" }}
          src={ProfileIcon}
          alt=""
        /> */}
        {(sessionStorage.getItem("source") === "Professional School of Indian Banking" ||  
              sessionStorage.getItem("source") === "Icon Public School" || 
              sessionStorage.getItem("source") === "Avinash College of Commerce" || sessionStorage.getItem("source") === "Datagami Technology Services Private Limited") && 
               <img
          style={{height:'3.5em',width:'9em'}}
          src={fundzpe}
          alt=""
        />}
       
      </div>
    </div>
  );
}

export default Navbar;
